<script context="module">
  import {External} from "../external";

  const elements = new Set();

  export function blurAll() {
    elements.forEach(function (element) {
      External.Tools.removeTextEditor(External.$(element));
    });
  }
</script>

<script>
  import { onDestroy, onMount } from "svelte";
  import { ignore, variableDictionary } from "./tools";

  let editor,
    jqContainer,
    isFocused = false;

  export let data,
    meta = {},
    onChange = ignore,
    onFocus = ignore,
    style = "",
    isMinimalistic = false,
    emailEditor = false;

  const tags = variableDictionary(meta.name);

  /**
   * Use this on the render data to replace the tags
   * @param string
   * @returns {string|*}
   */
  function loadTags(string) {
    if (string === "") {
      return "Click to edit";
    }

    if (isFocused || !meta.params) {
      return string;
    }

    const rxp = /\{([A-Za-z_]+)}/g;
    string = string.replace(rxp, function (match, group) {
      return meta.params[group];
    });

    return string;
  }

  export function focus() {
    const container = getContainer();

    External.Tools.addTextEditor({
      element: container,
      forceFixedPosition: !!meta.forceFixedPosition,
      addExtraButtons: meta.addExtraButtons !== false,
      addImageButton: !!meta.addImageButton,
      addMarketingTags: meta.addMarketingTags === false ? false : !isMinimalistic,
      marketingTags: tags,
      useEmailFontsOnly: meta.useEmailFontsOnly !== false,
      isMinimalistic: isMinimalistic,
      isEmailEditor: emailEditor === true,
      textAssistOptions: meta.textAssistOptions,
      callbackHandler: function (action) {
        if (action === "focus") {
          if (isFocused) {
            return;
          }

          isFocused = true;
          // const editor = getEditor(container);
          // editor.code(data);
        }
        if (action === "blur") {
          isFocused = false;
          const options = container.siblings(".note-editor").data("options");

          if (options.popupOpen) {
            return;
          }

          if (onChange) {
            const editor = getEditor(container);
            let code = editor.code();

            if (hasChange(code)) {

              const root = document.createElement("div");
              root.innerHTML = code;

              const removeEmptyElements = element => {
                if (!element.children.length && /^[ \t\r\n]*$/.test(element.textContent)) {
                  element.remove();
                }
              };

              // remove empty spans
              root.querySelectorAll("span").forEach(removeEmptyElements);
              // remove empty divs
              root.querySelectorAll("div").forEach(removeEmptyElements);
              // remove empty paragraphs
              root.querySelectorAll("p").forEach(removeEmptyElements);
              // some divs might've become empty, remove them
              root.querySelectorAll("div").forEach(removeEmptyElements);
              code = root.innerHTML;
              onChange(code);
            }
          }
        }
      }
    });

    const parentWrapper = container.parent();
    External.Tools.focusTextEditor(parentWrapper);

    onFocus();
  }

  function getContainer() {
    if (jqContainer == null) {
      jqContainer = External.$(editor);
      return jqContainer;
    }
    return jqContainer;
  }

  function getEditor(context) {
    const container = context ? context : getContainer();
    return container.hasClass("cpanel-text-editor") ? container : container.find(".cpanel-text-editor");
  }

  function hasChange(code) {
    return editor.innerHTML !== code;
  }

  onMount(function () {
    elements.add(editor);
    if (meta.focused) {
      focus();
    }
  });

  onDestroy(function () {
    if (editor) {
      const container = getContainer();
      const parentWrapper = container.parent();
      External.Tools.removeTextEditor(parentWrapper);
      elements.delete(editor);
    }
  });
</script>

<div bind:this={editor} on:click={focus} class="editor" style={style}>
  {@html data}
</div>

<style>
  .editor :global(a) {
    pointer-events: none;
  }

  .editor ul {
    list-style: disc;
    padding-left: 2em;
  }
</style>
